/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IncludeInClaim/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function IncludeInClaim({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/IncludeInClaim"
  
}) {
let chargeIsIncludedInInsuranceClaimValueData = fromData.useDataFormat({ viewPath,
context: 'charge',
path: 'is_included_in_insurance_claim',
format: fromFormat.booleanToYesNo,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="charge.is_included_in_insurance_claim"
 format="/Data/format.js booleanToYesNo"
 text={chargeIsIncludedInInsuranceClaimValueData}
 size="small"
/>
{children}
</React.Fragment>)
}